export const cookieSettingsContent = [
  {
    type: 'essential',
    title: 'containers.cookieDashboard.cookieSettings.content.title1',
    content: 'containers.cookieDashboard.cookieSettings.content.content1',
    moreInfo: [
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo1.item4',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo1.bubble4',
      },
    ],
  },

  {
    type: 'personal',
    title: 'containers.cookieDashboard.cookieSettings.content.title2',
    content: 'containers.cookieDashboard.cookieSettings.content.content2',
    moreInfo: [
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo1.item2',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo1.bubble2',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo2.item1',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo2.bubble1-v2',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo2.item2',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo2.bubble2',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo2.item3',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo2.bubble3',
      },
    ],
  },

  {
    type: 'marketing',
    title: 'containers.cookieDashboard.cookieSettings.content.title3',
    content: 'containers.cookieDashboard.cookieSettings.content.content3',
    moreInfo: [
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item3',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble3-v2',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item6',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble6-v2',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item7',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble7',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item8',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble8',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item9',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble9',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item10',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble10',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item11',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble11',
      },
      {
        item: 'containers.cookieDashboard.cookieSettings.content.moreInfo3.item12',

        bubble:
          'containers.cookieDashboard.cookieSettings.content.moreInfo3.bubble12',
      },
    ],
  },
];
